
export default function Testimonials() {
  const whatsappTestimonials = [
    {
      src: "https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/7bae145ef54ac11101d579233a291434.jpeg",
      alt: "Depoimento real de cliente via WhatsApp",
      name: "Vircilene do Carmo"
    },
    {
      src: "https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/8180da60e6de363935886ac297ceca52.jpeg",
      alt: "Depoimento real de cliente via WhatsApp",
      name: "Joana D\u2019arc"
    },
    {
      src: "https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/23d736e7df23122a6a5fb16833592dd1.jpeg",
      alt: "Depoimento real de cliente via WhatsApp",
      name: "Liliane Luna"
    },
    {
      src: "https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/57660a1140268e937dd2a62fa30cce40.jpeg",
      alt: "Depoimento real de cliente via WhatsApp",
      name: "Andressa de Oliveira"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Experiências de Quem Busca Justiça
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Relatos de pessoas que buscaram orientação jurídica para defender seus direitos trabalhistas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {whatsappTestimonials.map((item, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:border-[#C9A961] transition-all duration-300 flex flex-col">
              <div className="flex items-center gap-2 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A961] text-lg"></i>
                ))}
              </div>
              <div className="flex-1 flex items-center justify-center mb-4">
                <div className="w-full rounded-xl overflow-hidden shadow-md border border-gray-100" style={{ maxWidth: 340 }}>
                  <img
                    src={item.src}
                    alt={item.alt}
                    className="w-full h-auto object-top"
                  />
                </div>
              </div>
              <div className="flex items-center gap-4 mt-2">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#4A1C40] to-[#5A2C50] rounded-full">
                  <i className="ri-whatsapp-line text-[#C9A961] text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#4A1C40] text-base">{item.name}</p>
                  <p className="text-sm text-gray-600">Depoimento via WhatsApp</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#4A1C40] rounded-2xl p-8 text-center">
          <p className="text-white text-base leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            <i className="ri-information-line text-[#C9A961] mr-2"></i>
            <strong className="text-[#C9A961]">Nota sobre privacidade:</strong> Os depoimentos acima são baseados em experiências reais, 
            mas as identidades foram preservadas por sigilo profissional, conforme determina o Código de Ética da OAB. 
            Cada caso possui particularidades próprias e resultados podem variar conforme as circunstâncias específicas.
          </p>
        </div>
      </div>
    </section>
  );
}
